import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Our Work', path: '/our-work' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 lg:animate-fade-down ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/77d46a0f4a774521f072e7d3cc1d9be9/c5934c9d8b7147ad65626fd90d4dfe1a.png"
              alt="Sooner Blacktop"
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-semibold transition-colors cursor-pointer ${
                  isScrolled
                    ? 'text-gray-700 hover:text-yellow-500'
                    : 'text-white hover:text-yellow-400'
                } ${location.pathname === link.path ? 'text-yellow-500' : ''}`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:405-367-6799"
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-yellow-500' : 'text-white hover:text-yellow-400'
              }`}
            >
              <i className="ri-phone-line mr-2"></i>
              (405) 367-6799
            </a>
            <a
              href="#quote"
              className="inline-flex items-center px-6 py-3 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-500 transition-all whitespace-nowrap cursor-pointer lg:hover-lift"
            >
              <i className="ri-file-list-3-line mr-2"></i>
              Free Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
          >
            <i
              className={`text-2xl ${
                isScrolled ? 'text-gray-900' : 'text-white'
              } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-2 text-gray-700 font-semibold hover:text-yellow-500 transition-colors cursor-pointer"
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:405-367-6799"
              className="block py-2 text-gray-700 font-semibold hover:text-yellow-500 transition-colors cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              (405) 367-6799
            </a>
            <a
              href="#quote"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block w-full text-center px-6 py-3 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-500 transition-all cursor-pointer"
            >
              Free Quote
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
